import { takeEvery, put, fork } from "redux-saga/effects";
import * as actions from "../actions/breakDownDetailActions";
import * as api from "../../api/breakDownDetailApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { getFilesFromZip } from "../../common";

function* getTaskDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getTaskDetailById(action.payload);
        yield put(actions.setTaskDetailById(data || undefined));
        yield put(actions.resetTaskDetailById());
    } catch (error) {
        yield put(actions.setTaskDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getEkedEquipmentList(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getEkedEquipmentList(action.payload);
        yield put(actions.setEkedEquipmentList(data || undefined));
    } catch (error) {
        yield put(actions.setEkedEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* updateEkedEquipmentList(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateEkedEquipmentList(action.payload);
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.updateEkedEquipmentList(undefined));
        yield put(showErrorSnackbar(error));
        console.log(error);
    }
    yield put(setBackdrop());
}

function* getSameLevelListById(action) {
    try {
        const { data } = yield api.getSameLevelListById(action.payload);
        yield put(actions.setSameLevelListById(data || undefined));
        yield put(actions.resetSameLevelListById(data || undefined));
        yield put(actions.getBreakdownRootCauseList());
    } catch (error) {
        yield put(actions.setSameLevelListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownRootCauseList() {
    try {
        const { data } = yield api.getBreakdownRootCauseList();
        yield put(actions.setBreakdownRootCauseList(data || undefined));
        yield put(actions.resetRootCauses());
    } catch (error) {
        yield put(actions.setBreakdownRootCauseList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getBreakdownPoolList(action) {
    try {
        const { data } = yield api.getBreakdownPoolList();
        if (action.payload.editRequest) {
            data["editRequest"] = true;
            yield put(actions.setBreakdownPoolList(data || undefined));
            yield put(actions.resetBreakdownPoolList());
            yield put(actions.getBreakdownReasonList({ editRequest: true }));
        }
        if (action.payload.createSubTask) {
            data["createSubTask"] = true;
            yield put(actions.setBreakdownPoolList(data || undefined));
            yield put(actions.resetBreakdownPoolList());
        }
    } catch (error) {
        yield put(actions.setBreakdownPoolList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getBreakdownReasonList(action) {
    try {
        const { data } = yield api.getBreakdownReasonList();
        if (action.payload.editRequest) {
            data["editRequest"] = true;
            yield put(actions.setBreakdownReasonList(data));
            yield put(actions.resetBreakdownReasonList());
            yield put(actions.getBreakdownEffectList(data || undefined));
        }
        if (action.payload.breakDownReasonGroupReq) {
            data["breakDownReasonGroupReq"] = true;
            yield put(actions.setBreakdownReasonList(data));
            yield put(actions.resetBreakdownReasonList());
        }
    } catch (error) {
        yield put(actions.setBreakdownReasonList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getBreakdownReasonListWithPoolRelations(action) {
    try {
        const { data } = yield api.getBreakdownReasonListWithPoolRelations(action.payload);
        console.log("data: ", data);
        yield put(actions.setBreakdownReasonListWithPoolRelations(data));
    } catch (error) {
        yield put(actions.setBreakdownReasonListWithPoolRelations(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownEffectList() {
    try {
        const { data } = yield api.getBreakdownEffectList();
        yield put(actions.setBreakdownEffectList(data || undefined));
        yield put(actions.resetBreakdownEffectList());
    } catch (error) {
        yield put(actions.setBreakdownEffectList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* createSubTaskUnPlannedMaintenance(action) {
    try {
        const data = yield api.createSubTaskUnPlannedMaintenance(action.payload);
        yield put(actions.createSubTaskSuccess(data || undefined));
        yield put(actions.resetCreateSubTaskSuccess());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(actions.createSubTaskSuccess(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* playUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.playUnPlannedMaintenance(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* startUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.startUnPlannedMaintenance(action.payload);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* closeUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    // Support both plain taskId (old usage) and { taskId, p360Payload, plantId } (PDM User usage)
    const taskId = action.payload?.taskId ?? action.payload;
    const p360Payload = action.payload?.p360Payload ?? null;
    const plantId = action.payload?.plantId ?? null;
    try {
        const data = yield api.closeUnPlannedMaintenance(taskId);
        data["completeTask"] = true;
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));

        // P360 integration: only called after a successful close, and only for PDM User
        if (p360Payload) {
            try {
                const p360Response = yield api.postP360WorkOrderClosed(p360Payload, plantId);
                // p360Data is null when the plant has no configured P360 endpoint
                const p360Message = p360Response?.data?.message;
                console.log("P360 response message:", p360Message);
                if (p360Message) {
                    yield put(showSuccessSnackbar(p360Message));
                }
            } catch (p360Error) {
                // P360 failure must not affect the main close flow
                console.error("P360 WorkOrder/closed call failed:", p360Error);
                yield put(showErrorSnackbar(p360Error));
            }
        }
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* pauseUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.pauseUnPlannedMaintenance(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* reopenUnplannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const response = yield api.reopenUnplannedMaintenance(action.payload);

        yield put(showSuccessSnackbar(response));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* completeUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.completeUnPlannedMaintenance(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* updateUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.updateUnPlannedMaintenance(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addTechnicianUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addTechnicianUnPlannedMaintenance(action.payload);
        data["addMeOrFriend"] = true;
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* addUnPlannedMaintenanceOfTheReport(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.addUnplannedMaintenaceOfTheReports(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isDeletedReports());
        yield put(actions.resetIsDeletedReports());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getUnPlannedMaintenanceOfTheReport(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUnplannedMaintenaceOfTheReports(action.payload);
        yield put(actions.setUnPlannedMaintenanceOfTheReport(data || undefined));
    } catch (error) {
        yield put(actions.setUnPlannedMaintenanceOfTheReport(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteUnPlannedMaintenanceOfTheReport(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteUnplannedMaintenaceOfTheReports(action.payload);
        yield put(showSuccessSnackbar(data.message));
        yield put(actions.isDeletedReports());
        yield put(actions.resetIsDeletedReports());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* postUnplannedMaintenanceOfTheReports(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.postUnplannedMaintenanceOfTheReports(action.payload);
        if (action?.payload?.firstCall) {
            yield put(actions.setUnPlannedMaintenanceOfTheReportWithStatus({ firstCallRes: data } || undefined));
        }
        if (action?.payload?.fetchMoreData) {
            yield put(actions.setUnPlannedMaintenanceOfTheReportWithStatus({ fetchMoreDataRes: data } || undefined));
        }
    } catch (error) {
        yield put(actions.setUnPlannedMaintenanceOfTheReport(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* patchUnplannedMaintenanceOfTheReports(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.patchUnplannedMaintenanceOfTheReports(action.payload);
        yield put(actions.updateReportList());
        yield put(actions.resetUpdateReportList());
        yield put(showSuccessSnackbar(data));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
}
function* assignTaskUnPlannedMaintenance(action) {
    yield put(resetBackdrop());
    try {
        const data = yield api.assignTaskUnPlannedMaintenance(action.payload);
        yield put(showSuccessSnackbar(data));
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getListByStatusUnPlannedMaintenance(action) {
    try {
        const { data } = yield api.getListByStatusUnPlannedMaintenance(action.payload);
        if (action.payload.UserActiveTask) {
            data["UserActiveTask"] = true;
            data["goToStartedTask"] = false;
            data["startTask"] = false;
            yield put(actions.setListByStatusUnPlannedMaintenance(data || undefined));
            yield put(actions.resetListByStatusUnplanned_Maintenance());
        }
        if (action.payload.goToStartedTask) {
            data["goToStartedTask"] = true;
            data["startTask"] = false;
            data["UserActiveTask"] = false;
            yield put(actions.setListByStatusUnPlannedMaintenance(data || undefined));
            yield put(actions.resetListByStatusUnplanned_Maintenance());
        }
        if (action.payload.startTask) {
            data["startTask"] = true;
            data["rowData"] = action.payload.rowData;
            data["UserActiveTask"] = false;
            data["goToStartedTask"] = false;
            yield put(actions.setListByStatusUnPlannedMaintenance(data || undefined));
            yield put(actions.resetListByStatusUnplanned_Maintenance());
        }
    } catch (error) {
        yield put(actions.setListByStatusUnPlannedMaintenance(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getBreakdownReasonPlaceListByGroupIdAndPoolRelations(action) {
    try {
        const { data } = yield api.getBreakdownReasonPlaceListByGroupIdAndPoolRelations(action.payload);
        yield put(actions.setGetBreakdownReasonPlaceListByGroupIdAndPoolRelations(data || undefined));
        yield put(actions.resetGetBreakdownReasonPlaceListByGroupIdAndPoolRelations());
    } catch (error) {
        yield put(actions.setGetBreakdownReasonPlaceListByGroupIdAndPoolRelations(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getBreakdownReasonDetailListByPlaceId(action) {
    try {
        const { data } = yield api.getBreakdownReasonDetailListByPlaceId(action.payload);
        yield put(actions.setGetBreakdownReasonDetailListByPlaceId(data || undefined));
        yield put(actions.resetGetBreakdownReasonDetailListByPlaceId());
    } catch (error) {
        yield put(actions.setGetBreakdownReasonDetailListByPlaceId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getUnplannedFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getUnplannedFiles(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setUnplannedFiles(files || undefined));
    } catch (error) {
        yield put(actions.setUnplannedFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* addUnplannedFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addUnplannedFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getTaskHistoryByIdUnPlannedMaintenance(action) {
    try {
        const { data } = yield api.getTaskHistoryByIdUnPlannedMaintenance(action.payload);
        yield put(actions.setGetTaskHistoryByIdUnPlannedMaintenance(data || undefined));
    } catch (error) {
        yield put(actions.setGetTaskHistoryByIdUnPlannedMaintenance(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getMaintenancePauseReasonList() {
    try {
        const { data } = yield api.getMaintenancePauseReasonList();
        yield put(actions.setGetMaintenancePauseReasonList(data || undefined));
        yield put(actions.resetGetMaintenancePauseReasonList());
    } catch (error) {
        yield put(actions.setGetMaintenancePauseReasonList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getTechList(action) {
    try {
        const { data } = yield api.getTechListByPoolId(action.payload);
        data["rows"] = action.payload.rows;
        yield put(actions.setTechnicianList(data || undefined));
        yield put(actions.resetTechnicians());
    } catch (error) {
        yield put(actions.setTechnicianList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteUnplannedFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteUnplannedFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* closeManyUnplannedTasks(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.closeManyUnplannedTasks(action.payload);
        showSuccessSnackbar(data.message);
        yield put(actions.isUpdateTask());
        yield put(actions.resetIsUpdateTask());
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getCurrentUsersActiveTaskId(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.getCurrentUsersActiveTaskId(action.payload);
        yield put(actions.setCurrentUsersActiveTaskId(data || undefined));
    } catch (error) {
        yield put(actions.setCurrentUsersActiveTaskId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.DELETE_UNPLANNED_FILES, deleteUnplannedFiles);
    yield takeEvery(actions.Types.GET_TASK_DETAIL_BY_ID, getTaskDetailById);
    yield takeEvery(actions.Types.GET_EKED_EQUIPMENT_LIST_UNPLANNED, getEkedEquipmentList);
    yield takeEvery(actions.Types.UPDATE_EKED_EQUIPMENT_LIST_UNPLANNED, updateEkedEquipmentList);
    yield takeEvery(actions.Types.GET_SAME_LEVEL_LIST_BY_ID, getSameLevelListById);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_ROOT_CAUSE_LIST, getBreakdownRootCauseList);
    yield takeEvery(actions.Types.GET_BD_POOL_LIST, getBreakdownPoolList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_LIST, getBreakdownReasonList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_R_POOL_LIST, getBreakdownReasonListWithPoolRelations);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_EFFECT_LIST, getBreakdownEffectList);
    yield takeEvery(actions.Types.CREATE_SUBTASK_UNPLANNED_MAINTENANCE, createSubTaskUnPlannedMaintenance);
    yield takeEvery(actions.Types.PLAY_UNPLANNED_MAINTENANCE, playUnPlannedMaintenance);
    yield takeEvery(actions.Types.START_UNPLANNED_MAINTENANCE, startUnPlannedMaintenance);
    yield takeEvery(actions.Types.CLOSE_UNPLANNED_MAINTENANCE, closeUnPlannedMaintenance);
    yield takeEvery(actions.Types.PAUSE_UNPLANNED_MAINTENANCE, pauseUnPlannedMaintenance);
    yield takeEvery(actions.Types.REOPEN_UNPLANNED_MAINTENANCE, reopenUnplannedMaintenance);
    yield takeEvery(actions.Types.COMPLETE_UNPLANNED_MAINTENANCE, completeUnPlannedMaintenance);
    yield takeEvery(actions.Types.UPDATE_UNPLANNED_MAINTENANCE, updateUnPlannedMaintenance);
    yield takeEvery(actions.Types.ADD_TECHNICIAN_UNPLANNED_MAINTENANCE, addTechnicianUnPlannedMaintenance);
    yield takeEvery(actions.Types.ASSIGN_UNPLANNED_MAINTENANCE, assignTaskUnPlannedMaintenance);
    yield takeEvery(actions.Types.GETLIST_BYSTATUS_UNPLANNED_MAINTENANCE, getListByStatusUnPlannedMaintenance);
    yield takeEvery(actions.Types.GET_BDREASON_PLACELIST_BYGROUPID, getBreakdownReasonPlaceListByGroupIdAndPoolRelations);
    yield takeEvery(actions.Types.GET_BDREASON_DETAILLIST_BYPLACEID, getBreakdownReasonDetailListByPlaceId);
    yield takeEvery(actions.Types.GET_UNPLANNED_FILES, getUnplannedFiles);
    yield takeEvery(actions.Types.ADD_UNPLANNED_FILES, addUnplannedFiles);
    yield takeEvery(actions.Types.ADD_UNPLANNED_MAINTENANCE_OF_THE_REPORT, addUnPlannedMaintenanceOfTheReport);
    yield takeEvery(actions.Types.GET_UNPLANNED_MAINTENANCE_OF_THE_REPORT, getUnPlannedMaintenanceOfTheReport);
    yield takeEvery(actions.Types.DELETE_UNPLANNED_MAINTENANCE_OF_THE_REPORT, deleteUnPlannedMaintenanceOfTheReport);
    yield takeEvery(actions.Types.POST_UNPLANNED_MAINTENANCE_OF_THE_REPORT, postUnplannedMaintenanceOfTheReports);
    yield takeEvery(actions.Types.PATCH_UNPLANNED_MAINTENANCE_OF_THE_REPORT, patchUnplannedMaintenanceOfTheReports);
    yield takeEvery(actions.Types.GET_TASKHISTORY_BY_ID_UNPLANNED_MAINTENANCE, getTaskHistoryByIdUnPlannedMaintenance);
    yield takeEvery(actions.Types.GET_MAINTENANCE_PAUSE_REASON_LIST, getMaintenancePauseReasonList);
    yield takeEvery(actions.Types.GET_TECH_LIST_FOR_BREAK_DOWN_DETAIL, getTechList);
    yield takeEvery(actions.Types.CLOSE_MANY_UNPLANNED_TASKS, closeManyUnplannedTasks);
    yield takeEvery(actions.Types.GET_CURRENT_USERS_ACTIVE_TASK_ID, getCurrentUsersActiveTaskId);
}

const breakDownDetailSaga = [fork(watchAll)];

export default breakDownDetailSaga;
